import React from 'react';
import { motion } from 'framer-motion';

const SupasoLogoSpinner = ({ size = "normal" }) => {
    // Definimos tamaños escalables
    const baseSize = size === "small" ? 80 : 180;
    const logoSize = size === "small" ? 45 : 100;
    const strokeWidth = size === "small" ? 4 : 8;
    
    return (
        <div className="relative flex items-center justify-center" style={{ width: baseSize, height: baseSize }}>
            {/* Spinner Verde (Exterior) */}
            <motion.div
                className="absolute rounded-full"
                style={{
                    width: '90%',
                    height: '90%',
                    border: `${strokeWidth}px solid transparent`,
                    borderTopColor: '#00A400',
                    borderRightColor: '#00A400',
                    borderBottomColor: '#00A400',
                    zIndex: 1
                }}
                animate={{ rotate: 360 }}
                transition={{ duration: 12, repeat: Infinity, ease: "linear" }}
            />
            
            {/* Spinner Rojo (Interior) */}
            <motion.div
                className="absolute rounded-full"
                style={{
                    width: '74%',
                    height: '74%',
                    border: `${strokeWidth}px solid transparent`,
                    borderTopColor: '#FD3033',
                    borderLeftColor: '#FD3033',
                    borderBottomColor: '#FD3033',
                    zIndex: 2
                }}
                animate={{ rotate: -360 }}
                transition={{ duration: 10, repeat: Infinity, ease: "linear" }}
            />
            
            {/* Círculo Central Blanco con el Logo */}
            <div 
                className="relative z-10 bg-white rounded-full flex items-center justify-center shadow-lg"
                style={{ width: '60%', height: '60%' }}
            >
                <img 
                    src="https://supaso.org/logo.png" 
                    alt="SUPASO" 
                    style={{ width: '80%', height: '80%', objectFit: 'contain' }}
                    referrerPolicy="no-referrer"
                />
            </div>
        </div>
    );
};

export default SupasoLogoSpinner;
